import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import AliasProfile from "./AliasProfile";
import AliasTable from "./AliasTable";
import CreateAlias from "./CreateAlias";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;

const AliasesManagement = () => {
    const hasWritePermission = usePermission("sport:aliases.write");

    return (
        <div>
            <Routes>
                <Route path={"create"} element={<>{hasWritePermission && <CreateAlias />}</>}></Route>
                <Route path={":id/*"} element={<AliasProfile />}></Route>
                <Route path={""} element={<AliasTable />}></Route>
            </Routes>
        </div>
    );
};

export default AliasesManagement;
